/**
 * Regras de visibilidade dos botões da linha — extraídas da view para reuso e testes.
 * `perm` deve seguir o mesmo contrato de getPermissionFw (nome da permissão → boolean).
 */

export function showDocumentIntegrationButton(perm, shipment) {
  return (
    perm("expedicao.store") &&
    shipment.statusIntegracoes.shouldReintegrateDocument
  );
}

export function showCiotIntegrationButton(perm, shipment) {
  return (
    perm("expedicao.store") &&
    shipment.statusProcessoExpedicao.valor == 2 &&
    shipment.statusIntegracoes.statusCarregamentoDespesa.status.valor == 1 &&
    shipment.statusIntegracoes.statusIroute.valor == 3 &&
    shipment.statusIntegracoes.statusTargetRoteiro.status.valor == 1 &&
    shipment.statusIntegracoes.statusTargetCiot.status.valor != 1
  );
}

export function showEstornaCalculoButton(perm, shipment) {
  /* Mesma precedência && / || do método original na view */
  return (
    (perm("expedicao.calculo.estornar") &&
      shipment.statusProcessoExpedicao.valor != 1 &&
      (shipment.statusIntegracoes.statusCarregamentoDespesa.status.valor ==
        1 ||
        shipment.statusExpedicaoDespesa == 3) &&
      (shipment.cargaCiot == null &&
        (shipment.status.valor == 3 || shipment.status.valor == 6))) ||
    (shipment.cargaCiot != null &&
      shipment.cargaCiot.statusCiot == 2 &&
      (shipment.status.valor == 3 || shipment.status.valor == 6))
  );
}

export function showExpanseIntegrationButton(
  perm,
  permiteGerarDespesa,
  shipment
) {
  return (
    perm("expedicao.store") &&
    permiteGerarDespesa &&
    ((!shipment.statusIntegracoes.ishybridModule &&
      shipment.statusProcessoExpedicao.valor != 1 &&
      shipment.statusIntegracoes.statusCarregamentoDespesa.status.valor == 2 &&
      shipment.statusIntegracoes.statusIroute.valor == 3 &&
      shipment.statusIntegracoes.statusTargetRoteiro.status.valor == 1) ||
      shipment.statusIntegracoes.shouldReintegrateExpanse)
  );
}

export function showTargetIntegrationButton(perm, shipment) {
  return (
    perm("expedicao.store") &&
    shipment.statusProcessoExpedicao.valor != 1 &&
    ((shipment.statusIntegracoes.statusIroute.valor == 3 &&
      shipment.statusIntegracoes.statusTargetRoteiro.status.valor == 2) ||
      shipment.statusIntegracoes.shouldReintegrateTarget)
  );
}

export function showEndorsementIntegrationButton(perm, shipment) {
  return (
    perm("expedicao.store") &&
    ((shipment.statusProcessoExpedicao.valor != 1 &&
      shipment.statusIntegracoes.statusGeralAverbacao == 2 &&
      shipment.retira != 1) ||
      shipment.statusIntegracoes.shouldReintegrateEndorsement)
  );
}

export function showItrackIntegrationButton(perm, shipment) {
  return (
    perm("expedicao.store") &&
    (shipment.status.valor == 3 ||
      shipment.statusIntegracoes.shouldReintegrateItrack)
  );
}

export function showRoutingIntegrationButton(perm, shipment) {
  return (
    perm("expedicao.store") &&
    ((shipment.statusProcessoExpedicao.valor != 1 &&
      shipment.statusIntegracoes.statusGeralAverbacao == 1 &&
      shipment.statusIntegracoes.statusIroute.valor != 3) ||
      shipment.statusIntegracoes.shouldReintegrateRouting)
  );
}
